/**
 * Smart Project Copy Feature Constants
 *
 * Feature ID: 2116668
 * Title: Q4 | MH | Smart Project Copy
 */

/**
 * Environment variable to enable/disable Smart Project Copy feature
 */
export const ENABLE_SMART_PROJECT_COPY = process.env.REACT_APP_EnableSmartProjectCopy === '1'

/**
 * Clash detection states
 */
export const CLASH_STATES = {
    PENDING: 'PENDING',
    RESOLVED: 'RESOLVED',
    UNRESOLVED: 'UNRESOLVED',
} as const

/**
 * Best Practice application states
 */
export const BP_APPLICATION_STATES = {
    IDLE: 'IDLE',
    APPLYING: 'APPLYING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    CLASHES_DETECTED: 'CLASHES_DETECTED',
} as const

/**
 * Best Practice sync actions from backend
 */
export const BP_SYNC_ACTIONS = {
    NONE: 'NONE',
    SYNC_FROM_BP: 'SYNCFROMBP',
    CREATE_NEW_BP: 'CREATENEWBP',
    NULL: 'Null',
} as const

/**
 * BP application progress update interval (ms)
 */
export const BP_APPLICATION_PROGRESS_INTERVAL = 500

/**
 * Delay before refetching data after optimistic update (ms)
 */
export const REFETCH_DELAY_MS = 500

/**
 * Maximum badge count for clash icon
 */
export const MAX_CLASH_BADGE_COUNT = 99

/**
 * Toast message for successful BP application
 */
export const BP_SUCCESS_MESSAGE = 'Best Practices have successfully been applied!'

/**
 * Loading screen messages
 */
export const LOADING_MESSAGES = {
    TITLE: 'Applying Best Practices',
    MESSAGE: 'Specpoint is applying your Best Practices. You will be notified when the process is complete',
} as const

/**
 * Clash warning dialog messages
 */
export const CLASH_WARNING_MESSAGES = {
    TITLE: 'Clashes Detected',
    MESSAGE: 'Clashes have been detected. A newer version of the Family may have been released and added to the project. Specpoint is unable to apply some of the Best Practices.',
    INSTRUCTION: 'Click the clash icon in the right sidebar to review and resolve.',
} as const
